import { render, staticRenderFns } from "./suplatAccount.vue?vue&type=template&id=bd774358&scoped=true"
import script from "./suplatAccount.vue?vue&type=script&lang=js"
export * from "./suplatAccount.vue?vue&type=script&lang=js"
import style0 from "./suplatAccount.vue?vue&type=style&index=0&id=bd774358&prod&lang=less&scoped=true"
import style1 from "./suplatAccount.vue?vue&type=style&index=1&id=bd774358&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd774358",
  null
  
)

export default component.exports